// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  url: "https://devbackend.campuus.us/v1/",
  cryto: "s5u8x/A?D(G+KbPe",
  //schoolIDFlag: 51,
  schoolIDFlag: 50,
  academySchoolId: 52,
  codingCollegelId: 51,
  ccAdminAcademy: [
    { name: "Minerva Vargas", email: "mvargas@yopmail.com" },
    { name: "Yoshirah García", email: "yoshi@ayopmail.com" },
  ],
  apikeyFroala:
    "jUA1yB1B1D4D1G3F1pH-7oauC-13B1puxfbmjF3noaG3C2A5D5C4D3D2D4D=2I2=3D=3D",
  wsUrl: "https://socket.campuus.us:3000/",

  firebaseConfig: {
    apiKey: "AIzaSyCQbKSCXg9o-Jp3eNkHoca5MKjiJJpBVEg",
    authDomain: "campuus-8a44e.firebaseapp.com",
    projectId: "campuus-8a44e",
    storageBucket: "campuus-8a44e.firebasestorage.app",
    messagingSenderId: "241988701700",
    appId: "1:241988701700:web:7592aaa4311dd04bc8ef51",
    measurementId: "G-WGEFMB2YX2",
  },
};
